import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import { ChevronLeft, ChevronRight } from '@outdoor-voices/ui';
import css from './Paginator.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ChevronButton = function ChevronButton(_ref) {
  var disabled = _ref.disabled,
      onClick = _ref.onClick,
      right = _ref.right,
      type = _ref.type;
  return /*#__PURE__*/_jsxs("button", {
    "aria-label": "Go to ".concat(right ? 'next' : 'previous', " ").concat(type, " page"),
    className: cc([css.chevronButton, _defineProperty({}, css.chevronButtonDisabled, disabled)]),
    disabled: disabled,
    onClick: onClick,
    title: "Go to ".concat(right ? 'next' : 'previous', " ").concat(type, " page"),
    type: "button",
    children: [!right && /*#__PURE__*/_jsx(ChevronLeft, {}), right && /*#__PURE__*/_jsx(ChevronRight, {})]
  });
};

ChevronButton.defaultProps = {
  right: false
};
ChevronButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  right: PropTypes.bool,
  type: PropTypes.string.isRequired
};

var Paginator = function Paginator(_ref3) {
  var lastPageIndex = _ref3.lastPageIndex,
      onClickLast = _ref3.onClickLast,
      onClickNext = _ref3.onClickNext,
      onClickPrevious = _ref3.onClickPrevious,
      pageIndex = _ref3.pageIndex,
      results = _ref3.results,
      noResultsMessage = _ref3.noResultsMessage,
      type = _ref3.type,
      viewAllLink = _ref3.viewAllLink;

  if (!results && !noResultsMessage) {
    return false;
  }

  if (!results && noResultsMessage) {
    return /*#__PURE__*/_jsx("p", {
      className: css.noResults,
      children: noResultsMessage
    });
  }

  var onLastPage = lastPageIndex === pageIndex;
  var isPrevDisabled = pageIndex <= 0;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [viewAllLink && /*#__PURE__*/_jsx("a", {
      className: css.allReviewsLink,
      href: viewAllLink,
      children: "See All ".concat(type)
    }), /*#__PURE__*/_jsxs("div", {
      className: css.buttons,
      children: [/*#__PURE__*/_jsx(ChevronButton, {
        disabled: isPrevDisabled,
        onClick: onClickPrevious,
        type: type
      }), /*#__PURE__*/_jsx("div", {
        className: css.pageButton,
        children: pageIndex + 1
      }), /*#__PURE__*/_jsx("div", {
        className: css.pageButton,
        children: "/"
      }), /*#__PURE__*/_jsx("button", {
        "aria-label": "Go To Last Page Of ".concat(type),
        className: cc([css.pageButton, css.lastButton]),
        disabled: onLastPage,
        onClick: onClickLast,
        title: "Go To Last Page Of ".concat(type),
        type: "button",
        children: lastPageIndex + 1
      }), /*#__PURE__*/_jsx(ChevronButton, {
        disabled: onLastPage,
        onClick: onClickNext,
        type: type,
        right: true
      })]
    })]
  });
};

Paginator.defaultProps = {
  noResultsMessage: '',
  viewAllLink: false
};
Paginator.propTypes = {
  lastPageIndex: PropTypes.number.isRequired,
  noResultsMessage: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  onClickLast: PropTypes.func.isRequired,
  onClickNext: PropTypes.func.isRequired,
  onClickPrevious: PropTypes.func.isRequired,
  pageIndex: PropTypes.number.isRequired,
  results: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  viewAllLink: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
export default Paginator;